"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const evaluateObjectOfEntryVars = async ({ evaluator, entryVarsObject, }) => ((await Promise.all(Object.entries(entryVarsObject || {})
    .map(async ([key, entryVar]) => {
    if (!entryVar) {
        return [key, undefined];
    }
    return [key, await evaluator(entryVar)];
}))).reduce((accum, [key, value]) => (Object.assign(Object.assign({}, accum), { [key]: value })), {}));
exports.default = evaluateObjectOfEntryVars;
